import { useEffect } from "react";

export const SITE_URL = "https://www.kingbet9-official.com";

export const HOME_SEO = {
  title: "Kingbet9 Australia Mobile Casino - Best Online Slots & Games",
  description:
    "Play Kingbet9 Australia casino with top slots from JILI, BNG and VPower. Enjoy smooth gameplay, fast access and a seamless online experience.",
  url: `${SITE_URL}/`,
};

function setMeta(selector: string, content: string) {
  const tag = document.querySelector(selector);
  if (tag) {
    tag.setAttribute("content", content);
    return;
  }

  const newTag = document.createElement("meta");
  if (selector.includes("name=")) {
    const name = selector.match(/name="([^"]+)"/)?.[1];
    if (name) newTag.setAttribute("name", name);
  } else {
    const property = selector.match(/property="([^"]+)"/)?.[1];
    if (property) newTag.setAttribute("property", property);
  }
  newTag.setAttribute("content", content);
  document.head.appendChild(newTag);
}

function setCanonical(href: string) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

type PageSeo = {
  title: string;
  description: string;
  path: string;
  keywords?: string;
};

export function usePageSeo(page: PageSeo) {
  useEffect(() => {
    const url = `${SITE_URL}${page.path}`;
    document.title = page.title;
    setMeta('meta[name="description"]', page.description);
    if (page.keywords) setMeta('meta[name="keywords"]', page.keywords);
    setMeta('meta[property="og:title"]', page.title);
    setMeta('meta[property="og:description"]', page.description);
    setMeta('meta[property="og:url"]', url);
    setMeta('meta[name="twitter:title"]', page.title);
    setMeta('meta[name="twitter:description"]', page.description);
    setCanonical(url);

    return () => {
      document.title = HOME_SEO.title;
      setMeta('meta[name="description"]', HOME_SEO.description);
      setMeta('meta[property="og:title"]', HOME_SEO.title);
      setMeta('meta[property="og:description"]', HOME_SEO.description);
      setMeta('meta[property="og:url"]', HOME_SEO.url);
      setMeta('meta[name="twitter:title"]', HOME_SEO.title);
      setMeta('meta[name="twitter:description"]', HOME_SEO.description);
      setCanonical(HOME_SEO.url);
    };
  }, [page.title, page.description, page.path, page.keywords]);
}
